var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MatchHeroBanner',{attrs:{"hero-image":_vm.heroData.heroImage,"mobile-hero-image":_vm.heroData.heroImageWap,"alt":_vm.heroData.alt}})
}
var staticRenderFns = []

export { render, staticRenderFns }